import { getFeaturePanelDefinition } from "../feature-panel-registry.ts";
import type { RuntimeFeatureModule } from "../runtime-feature-registry.ts";
import {
  applyTextEffectValue,
  resetTextEffectValue,
} from "../shared/page-text-effects.ts";
import {
  createRangeControl,
  formatNumber,
  normalizeSteppedValue,
  parseNumericConfig,
} from "../shared/feature-value.ts";

const variable = "--migrosone-a11y-line-height";
const attribute = "data-migrosone-a11y-line-spacing";
const fallback = {
  defaultValue: 1.5,
  min: 1.2,
  max: 2,
  step: 0.1,
};

function getConfig(config: unknown) {
  return parseNumericConfig({
    config,
    defaultKeys: ["lineHeight", "scale"],
    fallback,
  });
}

const definition = getFeaturePanelDefinition("line-spacing");

if (!definition) {
  throw new Error("Missing line-spacing feature definition");
}

export const lineSpacingFeatureModule: RuntimeFeatureModule = {
  key: "line-spacing",
  definition,
  isSupported({ document }) {
    return Boolean(document.head && document.documentElement);
  },
  renderControl({ config, document, onPreferenceChange, preference }) {
    return createRangeControl({
      config: getConfig(config),
      document,
      label: "Satır aralığı",
      onPreferenceChange,
      preference,
    });
  },
  apply({ config, document, preference }) {
    const numericConfig = getConfig(config);
    const value = normalizeSteppedValue(preference, numericConfig);
    applyTextEffectValue({
      attribute,
      document,
      value: formatNumber(value),
      variable,
    });
  },
  reset({ config, document }) {
    resetTextEffectValue({ attribute, document, variable });
    const numericConfig = getConfig(config);
    applyTextEffectValue({
      attribute,
      document,
      value: formatNumber(numericConfig.defaultValue),
      variable,
    });
  },
};
